const primaryRecipients = ["info@bluezoneexperience.cr"]

// Add any backup or owner inboxes here if you want them copied on website inquiries.
const ccRecipients: string[] = []

const websiteName = "Paraiso Presidential 20"
const websiteUrl = "https://paraisopresidential20.com"

const inquirySubject = `${websiteName} | Website Booking Inquiry`
const inquiryBody = [
  "Hello Blue Zone Experience,",
  "",
  `I am interested in booking ${websiteName}.`,
  "",
  "This inquiry was submitted through the website:",
  websiteUrl,
  "",
  "Here are my details:",
  "",
  "Name:",
  "Email:",
  "Phone / WhatsApp:",
  "Preferred dates:",
  "Number of guests:",
  "Questions or details:",
].join("\n")

const buildMailtoHref = (to: string[], subject: string, body: string, cc: string[] = []) => {
  const params: string[] = []

  params.push(`subject=${encodeURIComponent(subject)}`)
  params.push(`body=${encodeURIComponent(body)}`)

  if (cc.length > 0) {
    params.push(`cc=${encodeURIComponent(cc.join(","))}`)
  }

  return `mailto:${to.join(",")}?${params.join("&")}`
}

export const bookingContactEmail = primaryRecipients[0]
export const bookingContactMailtoHref = buildMailtoHref(primaryRecipients, inquirySubject, inquiryBody, ccRecipients)
